import React from 'react';

const Header = () => {
  return (
    <header>
      <div className="domain-banner">
        <h2>agiagent.dev is FOR SALE</h2>
      </div>
    </header>
  );
};

export default Header; 